module.exports = __webpack_public_path__ + "static/media/33.fad0f623.wav";